import { TAILWIND_COLORS } from "#src/utils/common";
import { Typography } from "@lockerpm/design";
import { XClose } from "@untitled-ui/icons-react";
import { twMerge } from "tailwind-merge";

const sizes = ["sm", "md", "lg"] as const;

const tailwindSizeClasses: { [C in (typeof sizes)[number]]: string } = {
  sm: "px-2 py-[0.1875rem] text-xs",
  md: "px-[0.5625rem] py-0.5 text-sm",
  lg: "px-2.5 py-1 text-sm",
};

const tailwindIconSizeClasses: { [C in (typeof sizes)[number]]: string } = {
  sm: "h-2.5 w-2.5 min-w-2.5 m-0.5",
  md: "h-3 w-3 min-w-3 m-0.5",
  lg: "h-3.5 w-3.5 min-w-3.5 m-[0.1875rem]",
};

interface ITagProps {
  name: string;
  size?: (typeof sizes)[number];
  maxWidth?: number;
  onRemove?: () => void;
}

export const TagV2 = ({
  name,
  size = "md",
  maxWidth = 6,
  onRemove,
}: ITagProps) => {
  return (
    <div
      className={twMerge(
        "rounded-md border border-solid border-gray-v2-300 flex gap-[0.1875rem] items-center w-fit",
        tailwindSizeClasses[size],
        onRemove ? "pr-1" : undefined
      )}
    >
      <Typography.Text
        ellipsis={{
          tooltip: {
            color: TAILWIND_COLORS["gray-v2-900"],
            title: (
              <p className="text-white text-xs font-semibold text-center">
                {name}
              </p>
            ),
          },
        }}
        style={{ maxWidth: `${maxWidth}rem` }}
        className="font-medium text-gray-v2-900"
      >
        {name}
      </Typography.Text>

      {onRemove ? (
        <XClose
          className={`cursor-pointer text-gray-v2-400 ${tailwindIconSizeClasses[size]}`}
          onClick={onRemove}
        />
      ) : null}
    </div>
  );
};
